import styled from 'styled-components';
import React, { useContext } from 'react';
import MonitorLabel from './MonitorLabel';
import MonitorContext from '../../MonitorContext';
import { useSelector } from 'react-redux';
import { getStylesObj } from '../../../../helpers/utils';
const StyledDiv = styled.div<any>`
  background-color: transparent;
  color: white;
  padding-left: 2px;
  border: inset 1px white;
  text-transform: uppercase;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  height: auto;
  min-height: 19px;
`;
export interface ILongStyleButtonProps {
  field: string;
  style?: any;
  endWithColon?: boolean;
}

export default function LongStyledButton(props: ILongStyleButtonProps) {
  const { field, style, ...rest } = props;
  const context = useContext<any>(MonitorContext);
  const monitorFieldKey = `${context.monitor}_${field}`;
  const s80 = useSelector((state: any) => state.executor.s80);
  const { monitorFields } = s80;

  const styleObj = getStylesObj(monitorFields[monitorFieldKey]);
  return (
    <StyledDiv {...rest} style={{ ...styleObj, ...style }}>
      <MonitorLabel {...props} />
    </StyledDiv>
  );
}
